import React from 'react';
import AnalizeClienti from './Analize';
import { Bar, Chart } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels'
import SpecificComponent from '../../commons/SpecificComponent';

export default class TrendDePastrareClientiTrimestru extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
            listaTrimestre:[]
}
    }

     componentDidMount(){
         this.getAnalizaSemestru()
         Chart.plugins.unregister(ChartDataLabels);
    }

    getAnalizaSemestru = async()=>{
        let analiza = new AnalizeClienti();

        let analizaTrimestru =await analiza.analizaPeSemestru()

        // console.warn('analizaTrimestru :', analizaTrimestru);


        let trimestre = [{label:this.dictionary.financiarContabil.trimestrul + ' 1' , value:analizaTrimestru.semestrul1.nrClientiFacturati},
                         {label:this.dictionary.financiarContabil.trimestrul + ' 2' , value:analizaTrimestru.semestrul2.nrClientiFacturati},
                         {label:this.dictionary.financiarContabil.trimestrul + ' 3' , value:analizaTrimestru.semestrul3.nrClientiFacturati},
                         {label:this.dictionary.financiarContabil.trimestrul + ' 4' , value:analizaTrimestru.semestrul4.nrClientiFacturati},
                        ]
                        if(analizaTrimestru.semestrul1.nrClientiFacturati === 0 &&  analizaTrimestru.semestrul2.nrClientiFacturati === 0 && analizaTrimestru.semestrul3.nrClientiFacturati === 0 && analizaTrimestru.semestrul4.nrClientiFacturati === 0){
                            trimestre = null
                        }
                        // console.log('trimestre :', trimestre);
        this.setState({listaTrimestre:trimestre})
    }
     render() { 
       return (
          <div>
   
              <div className='container'>

             {this.state.listaTrimestre && 
              <Bar
                                                     
                                                     datasetKeyProvider={()=>{return Math.random()}}
                                                    // getElementAtEvent={(element)=>this.getLineData(element,i)}
                                                                plugins ={[ChartDataLabels]}
                                                    
                                                        data ={{
                                                            labels:this.state.listaTrimestre.map((r)=>{return(r.label)}),
                                                            datasets:[
                                                                {
                                                                 //    label:ch.chartData.map((r)=>{return(Number(r))}) ,
                                                                    backgroundColor: ['red','green','blue', 'yellow'],
                                                                    hoverBackgroundColor: ['red','green','blue', 'yellow'],
                                                                    data:this.state.listaTrimestre.map((r)=>{return(Number(r.value.toFixed(2)))}),
                                                                    
                                                                }
                                                            ],
                                                            
                                    
                                                        }}
                            
                                                        options={{
                            
                                                            onClick: function (evt, elements) {
                            
                                                                let selectedIndex = null
                                                                if (elements && elements.length) {
                                                                    var segment = elements[0];
                                                                    this.update();
                                                                    if (selectedIndex !== segment["_index"]) {
                                                                        selectedIndex = segment["_index"];
                                                                        segment._model.outerRadius += 20;
                                                                    }
                                                                    else {
                                                                        selectedIndex = null;
                                                                    }
                                                                }
                                                            },
                                                            layout:{
                                                                padding:60,
                                                                height:300
                                                            },
                            
                                                            plugins:{
                                                               
                                                                datalabels:{
                                                                    color:'black',
                                                                    formatter:(value,context)=>{
                                                                        //  console.log('value :', value);
                                                                     //    console.log('context :', );
                                                                       
                                                                            return value
                                                                       
                                                                    },
                                                                    font:{
                                                                        size:16,
                                                                        weight:600
                                                                    },
                                                                    align:'end',
                                                                    display:'auto',
                                                                    clamp:true
                                                                    
                                                                       
                                                                   },
                                                                   
                                                               },
                                                            legend:{
                                                                display:false
                                                             }
                                                        }}
                                                    
                                                        />
                                                    }

                                                    {
                                                       !this.state.listaTrimestre &&
                                                       <div style={{width:'45%', display:'inline-block'}}>
                         
                            <h4 style={{color:'red', 
                                        letterSpacing:1,
                                        fontWeight:600 }}>Lista nu dispune de informatiile necesare pentru afisarea graficului</h4>

                        </div>
                                                    }
                         </div>

         </div>
        );
       }
}